<mat-icon [svgIcon]="icon" *ngIf="icon"></mat-icon>
<span class="message" [transloco]="message" [translocoParams]="messageParams"></span>
<button mat-flat-button *ngIf="action" (click)="onAction()">{{action}}</button>
<button mat-icon-button *ngIf="!action" (click)="onAction()"><mat-icon>close</mat-icon></button>
